'use client';
import { isNumber } from '@s7/utils';
import { getSide, getAlignment, getSideAxis, evaluate } from '../../utils/base.js';

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function convertValueToCoords(state, options) {
    return _convertValueToCoords.apply(this, arguments);
}
function _convertValueToCoords() {
    _convertValueToCoords = _async_to_generator(function*(state, options) {
        const { placement, platform, elements } = state;
        const rtl = yield platform.isRTL == null ? void 0 : platform.isRTL.call(platform, elements.floating);
        const side = getSide(placement);
        const alignment = getAlignment(placement);
        const isVertical = getSideAxis(placement) === 'y';
        const mainAxisMulti = [
            'left',
            'top'
        ].includes(side) ? -1 : 1;
        const crossAxisMulti = rtl && isVertical ? -1 : 1;
        const rawValue = evaluate(options, state);
        // eslint-disable-next-line prefer-const
        let { mainAxis, crossAxis, alignmentAxis } = isNumber(rawValue) ? {
            mainAxis: rawValue,
            crossAxis: 0,
            alignmentAxis: null
        } : _extends({
            mainAxis: 0,
            crossAxis: 0,
            alignmentAxis: null
        }, rawValue);
        if (alignment && isNumber(alignmentAxis)) {
            crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
        }
        return isVertical ? {
            x: crossAxis * crossAxisMulti,
            y: mainAxis * mainAxisMulti
        } : {
            x: mainAxis * mainAxisMulti,
            y: crossAxis * crossAxisMulti
        };
    });
    return _convertValueToCoords.apply(this, arguments);
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const offset = (options = 0)=>({
        name: 'offset',
        options,
        fn (state) {
            return _async_to_generator(function*() {
                const { x, y } = state;
                const diffCoords = yield convertValueToCoords(state, options);
                return {
                    x: x + diffCoords.x,
                    y: y + diffCoords.y,
                    data: diffCoords
                };
            })();
        }
    });

export { convertValueToCoords, offset };
//# sourceMappingURL=offset.js.map
